import React from 'react'
import {Card, Paper, Skeleton} from "@mantine/core";
import uuid from "react-uuid";

export const MultipleActivitySkeleton = ( { count } : { count : number } ) => {
    const key = uuid();
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <Card shadow="sm" padding="lg" radius="md" withBorder className="min-w-full" key={`${key}-${index}`}>
                    <Skeleton height={200} mb="xl"/>
                    <Skeleton height={12} radius="xl"/>
                    <Skeleton height={12} mt={8} radius="xl"/>
                    <Skeleton height={12} mt={8} width="70%" radius="xl"/>
                </Card>
            ))}
        </>
    )
}

export const MultipleRegistrationActivitySkeleton = ( { count } : { count : number } ) => {
    const key = uuid();
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div className="shadow-sm rounded border border-gray-200 h-[100px] flex gap-[10px]" key={`${key}-${index}`}>
                    <Skeleton height={"100%"} width={200} mb="xl"/>
                    <div className="space-y-[20px] py-5">
                        <Skeleton height={20} radius="xl" w={600}/>
                        <Skeleton height={20} radius="xl" w={300}/>
                    </div>
                </div>

                // <Card shadow="sm" radius="md" withBorder
                //       className="w-full h-[100px]"
                //       key={`${key}-${index}`} p={0}>
                //     <div className="flex gap-1">
                //         <Skeleton height={100} width={200} mb="xl"/>
                //
                //         <div className="bg-red-600">
                //
                //             <Skeleton height={20} width="100%" radius="xl"/>
                //             <Skeleton height={12} width="100%" radius="xl"/>
                //             <Skeleton height={12} width="100%" radius="xl"/>
                //         </div>
                //     </div>
                // </Card>
            ))}
        </>
    )
}




export const MultipleNotificationSkeleton = ( { count } : { count : number } ) => {
    const key = uuid();
    return (
        <div className="space-y-3">
            {Array.from({ length: count }).map((_, index) => (
                <Paper withBorder p="lg" shadow="sm" key={`${key}-${index}`}>
                    <Skeleton height={12} radius="xl" />
                    <Skeleton height={12} mt={10} radius="xl" />
                    <Skeleton height={12} mt={10} radius="xl" />
                    <Skeleton height={12} mt={10} width="70%" radius="xl" />
                </Paper>
            ))}
        </div>
    )
}

